module.exports = __webpack_public_path__ + "img/Sakralbau_8_b.f47b58f9.jpg";